import React, { useRef } from 'react';

const TiltPhoto = ({ src, alt }) => {
  const cardRef = useRef(null);
  const rafRef  = useRef(null);
  const isHover = useRef(false);

  const handleMouseMove = (e) => {
    if (!cardRef.current) return;
    const rect = cardRef.current.getBoundingClientRect();

    // Normalised cursor position: -1 to +1
    const nx = ((e.clientX - rect.left) / rect.width  - 0.5) * 2;
    const ny = ((e.clientY - rect.top)  / rect.height - 0.5) * 2;

    const maxTilt = 14; // degrees
    const rotateY =  nx * maxTilt;
    const rotateX = -ny * maxTilt;

    // Spotlight position as %
    const mx = ((e.clientX - rect.left) / rect.width  * 100).toFixed(1);
    const my = ((e.clientY - rect.top)  / rect.height * 100).toFixed(1);

    if (rafRef.current) cancelAnimationFrame(rafRef.current);
    rafRef.current = requestAnimationFrame(() => {
      if (!cardRef.current) return;
      cardRef.current.style.transform =
        `rotateX(${rotateX}deg) rotateY(${rotateY}deg) scale3d(1.03,1.03,1.03)`;
      cardRef.current.style.setProperty('--mx', `${mx}%`);
      cardRef.current.style.setProperty('--my', `${my}%`);
      cardRef.current.classList.add('tilting');
    });
  };

  const handleMouseEnter = () => { isHover.current = true; };

  const handleMouseLeave = () => {
    isHover.current = false;
    if (rafRef.current) cancelAnimationFrame(rafRef.current);
    if (!cardRef.current) return;
    cardRef.current.style.transition = 'transform 0.5s cubic-bezier(0.23,1,0.32,1)';
    cardRef.current.style.transform  = 'rotateX(0deg) rotateY(0deg) scale3d(1,1,1)';
    cardRef.current.classList.remove('tilting');
    // Reset transition after the spring settles
    setTimeout(() => {
      if (cardRef.current) cardRef.current.style.transition = 'transform 0.08s linear';
    }, 500);
  };

  return (
    <div
      className="pf-tilt-wrapper"
      onMouseMove={handleMouseMove}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <div ref={cardRef} className="pf-tilt-card">
        <div className="pf-window-bar" aria-hidden="true">
          <span className="pf-window-dot pf-window-dot-red" />
          <span className="pf-window-dot pf-window-dot-yellow" />
          <span className="pf-window-dot pf-window-dot-green" />
        </div>
        <img src={src} alt={alt} className="pf-hero-photo" />
      </div>
    </div>
  );
};

export { TiltPhoto };
